import { useContext } from 'react';
import { BandwidthContext } from './BandwidthContext';

export const useBandwidthContext = () => useContext(BandwidthContext);
